import React from 'react'

const VideoCardIcon = ({ fillColor, size }) => (
  <svg width={size} height={size} viewBox='0 0 30 30'>
    <defs>
      <pattern id='bvideocard' patternUnits='objectBoundingBox' x='0%' width='100%' height='100%'>
        <use xlinkHref='#avideocard' />
      </pattern>
      <path
        d='M16.0267857 1.65306122c1.3307784.00152507 2.4092131 1.09707772 2.4107143 2.4489796v9.79591838c-.0015012 1.3519019-1.0799359 2.4474545-2.4107143 2.4489796H3.97321429C2.64243588 16.3454137 1.56400124 15.2498611 1.5625 13.8979592V4.10204082c.00150124-1.35190188 1.07993588-2.44745453 2.41071429-2.4489796H16.0267857zm0-1.2244898H3.97321429c-1.99710111 0-3.61607143 1.64466827-3.61607143 3.6734694v9.79591838c0 2.0288011 1.61897032 3.6734694 3.61607143 3.6734694H16.0267857c1.9971011 0 3.6160714-1.6446683 3.6160714-3.6734694V4.10204082c0-2.02880113-1.6189703-3.6734694-3.6160714-3.6734694zM8.50204241 5.88287756L12.7547473 8.475c.1815341.11064589.2926101.30993811.2926101.525 0 .21506189-.111076.41435411-.2926101.525l-4.25270489 2.5921224c-.18618671.1134866-.41807229.1164588-.60701837.0077807-.18894608-.1086781-.30573833-.3122043-.30573833-.5327807V6.40787755c0-.2205763.11679225-.42410251.30573833-.53278064.18894608-.10867813.42083166-.10570587.60701837.00778064z'
        id='cvideocard'
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(-540 -302)'>
        <path fill='url(#bvideocard)' d='M0 0h219v333H0z' transform='translate(532 295)' />
        <g transform='translate(545 308)'>
          <mask id='dvideocard' fill='#fff'>
            <use xlinkHref='#cvideocard' />
          </mask>
          <use fill={fillColor || '#C4C4D1'} fillRule='nonzero' xlinkHref='#cvideocard' />
        </g>
      </g>
    </g>
  </svg>
)

export default VideoCardIcon
